import { Avatar, Collapse, IconButton, withWidth } from "@material-ui/core";
import moment from "moment-timezone";

import React from "react";
import {
  IZYTableCell,
  IZYTableRow,
} from "../../../components/CustomStyles/CustomTable";
import Img from "../../../components/Img";
import { formatCurrency } from "../../../components/Utils/Currency";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { css, cx } from "emotion";
import PrintIcon from "@material-ui/icons/Print";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import { Skeleton } from "@material-ui/lab";

const user = JSON.parse(localStorage.getItem("user"));
const ListRow = ({
  transaction,
  number,
  access,
  arrStatus,
  status,
  handleChat,
  handleOpenModal,
  handleUpdateProgress,
  handleShowQR,
  handleUpdateRunnerRequest,
  handleClickPrint,
}) => {
  const order = transaction?.orders[0];
  const tenant = order?.tenant;

  const [openRow, setOpenRow] = React.useState(false);
  const getOrderStatus = (key) => {
    let find = arrStatus?.find((val) => val.status === key);

    if (find) {
      return find.title;
    } else {
      return "";
    }
  };

  return status?.status === "unpaid" ? (
    <div className="w-100 d-flex flex-column justify-content-start align-items-start rounded-8px border-1-secondary mb-3">
      <div className="bg-fafafa d-flex justify-content-start align-items-center w-100 border-bottom-1-secondary">
        <div className="px-3 py-2 border-right-1-secondary">
          <span className="font-bold font-14">No. {number}</span>
        </div>
        <div className="px-3 py-2">
          {transaction?.use_delivery && (
            <label className="badge-purple mb-0 mr-2">Delivery Order</label>
          )}
          {!transaction?.use_delivery &&
            transaction?.pickup &&
            transaction?.pickup?.id !== 0 && (
              <label className="badge-blue mb-0 mr-2">Pickup Point Order</label>
            )}
          {!transaction?.use_delivery &&
            transaction?.delivery &&
            transaction.delivery.id > 0 && (
              <label className="badge-purple mb-0">Delivery Order</label>
            )}
          {!transaction?.use_delivery &&
            transaction?.cons_type &&
            transaction?.cons_type === "room" && (
              <label className="badge-orange mb-0 mr-2">
                Send To Room : {transaction?.room_number}
              </label>
            )}
          {!transaction?.use_delivery &&
            transaction?.cons_type &&
            transaction?.cons_type === "table" && (
              <label className="badge-orange mb-0 mr-2">
                Send To Table : {transaction?.table_number}
              </label>
            )}
          {order?.runner_request === true && order?.runner_picked === false && (
            <label
              className="badge-orange mb-0"
              style={{ padding: "4px 15px" }}
            >
              <DirectionsRunIcon style={{ marginRight: 15, height: 21 }} /> The
              runner has been requested
            </label>
          )}
          {order?.runner_request === true && order?.runner_picked === true && (
            <label className="badge-green mb-0" style={{ padding: "4px 15px" }}>
              <DirectionsRunIcon style={{ marginRight: 15, height: 21 }} /> The
              runner has already taken your item
            </label>
          )}
        </div>
        <div className="px-3 py-2 ml-auto font-10 text-gray-757575">
          {moment(transaction.create_time)
            .tz(tenant?.property?.timezone)
            .format("DD MMMM YYYY HH:mm z")}
        </div>
      </div>
      <div className="row w-100 mx-0 bg-fafafa">
        <div className="col-md-3 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <h5 className="font-bold font-16 text-blue text-capitalize mb-0">
              {transaction?.user?.name}
            </h5>
            <span className="font-bold font-10 text-gray-757575">
              {transaction?.unique_id}
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              Payment Method
            </span>
            <span className="font-bold font-12 d-block">
              {transaction?.payment_method || "-"}
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              Status Pembayaran
            </span>
            <span className="font-bold font-12 d-block">
              {transaction?.invoice &&
                transaction?.invoice?.status === "PENDING" && (
                  <label className="badge-blue mb-0">PENDING</label>
                )}
              {transaction?.invoice &&
                transaction?.invoice?.status === "EXPIRED" && (
                  <label className="badge-orange mb-0">EXPIRED</label>
                )}
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              Total Transaksi
            </span>
            <span className="font-bold font-12 text-success d-block">
              {formatCurrency(
                tenant?.property?.currency,
                transaction?.total_amount?.toString()
              )}
            </span>
          </div>
        </div>
        <div className="col-md-3 col-12 p-3">
          <div className="d-flex justify-content-end align-items-start w-100 h-100">
            <button
              type="button"
              className="btn btn-blue btn-outline btn-sm d-sm-block"
              onClick={() => handleOpenModal(transaction)}
            >
              View Detail Invoice
            </button>
          </div>
        </div>
        {transaction?.transaction_note &&
          transaction?.transaction_note !== "" && (
            <div className="col-12 px-3 py-2 mb-2">
              <span
                className="font-12 p-2"
                style={{
                  background: "#ffecb3",
                  borderLeft: "6px solid #ff9800",
                  borderRadius: 4,
                }}
              >
                <strong>Catatan Pembeli: </strong>{" "}
                {transaction?.transaction_note}
              </span>
            </div>
          )}
      </div>
      <div className="bg-white d-flex justify-content-end align-items-center w-100 p-3">
        <div className="mr-auto">
          {transaction?.user?.phone &&
            transaction?.user?.phone !== "" &&
            user?.type === "staff" && (
              <button
                type="button"
                className="btn btn-blue btn-outline btn-sm font-10"
                onClick={() => handleChat(transaction)}
                style={{ paddingLeft: 33, paddingRight: 33, marginRight: 15 }}
              >
                Chat
              </button>
            )}
        </div>
      </div>
    </div>
  ) : (
    <div className="w-100 d-flex flex-column justify-content-start align-items-start rounded-8px border-1-secondary mb-3">
      <div className="bg-fafafa d-flex justify-content-start align-items-center w-100 border-bottom-1-secondary">
        <div className="px-3 py-2 border-right-1-secondary">
          <span className="font-bold font-14">No. {number}</span>
        </div>
        <div className="px-3 py-2">
          {transaction?.use_delivery && (
            <label className="badge-purple mb-0 mr-2">Delivery Order</label>
          )}
          {!transaction?.use_delivery &&
            transaction?.pickup &&
            transaction?.pickup?.id !== 0 && (
              <label className="badge-blue mb-0 mr-2">Pickup Point Order</label>
            )}
          {!transaction?.use_delivery &&
            transaction?.delivery &&
            transaction.delivery.id > 0 && (
              <label className="badge-purple mb-0">Delivery Order</label>
            )}
          {!transaction?.use_delivery &&
            transaction?.cons_type &&
            transaction?.cons_type === "room" && (
              <label className="badge-orange mb-0 mr-2">
                Send To Room : {transaction?.room_number}
              </label>
            )}
          {!transaction?.use_delivery &&
            transaction?.cons_type &&
            transaction?.cons_type === "table" && (
              <label className="badge-orange mb-0 mr-2">
                Send To Table : {transaction?.table_number}
              </label>
            )}
          {order?.runner_request === true && order?.runner_picked === false && (
            <label
              className="badge-orange mb-0"
              style={{ padding: "4px 15px" }}
            >
              <DirectionsRunIcon style={{ marginRight: 15, height: 21 }} /> The
              runner has been requested
            </label>
          )}
          {order?.runner_request === true && order?.runner_picked === true && (
            <label className="badge-green mb-0" style={{ padding: "4px 15px" }}>
              <DirectionsRunIcon style={{ marginRight: 15, height: 21 }} /> The
              runner has already taken your item
            </label>
          )}
        </div>
        <div className="px-3 py-2 ml-auto font-10 text-gray-757575">
          {moment(transaction.create_time)
            .tz(tenant?.property?.timezone)
            .format("DD MMMM YYYY HH:mm z")}
        </div>
      </div>
      <div className="row w-100 mx-0 bg-fafafa">
        <div className="col-md-3 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <h5 className="font-bold font-16 text-blue text-capitalize mb-0">
              {transaction?.user?.name}
            </h5>
            <span className="font-bold font-10 text-gray-757575">
              {transaction?.unique_id}
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              Pickup Point
            </span>
            <span className="font-bold font-12 d-block">
              {transaction?.pickup?.name || "-"}
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              Status Pesanan
            </span>
            <span className="font-bold font-12 d-block">
              {order.progress === "new" && (
                <label className="badge-blue mb-0">
                  {getOrderStatus(order?.progress)}
                </label>
              )}
              {order.progress === "process" && (
                <label className="badge-orange mb-0">
                  {getOrderStatus(order?.progress)}
                </label>
              )}
              {order.progress === "ready" && (
                <label className="badge-old-green mb-0">
                  {getOrderStatus(order?.progress)}
                </label>
              )}
              {order.progress === "delivery" && (
                <label className="badge-dark-blue mb-0">
                  {getOrderStatus(order?.progress)}
                </label>
              )}
              {order.progress === "complete" && (
                <label className="badge-green mb-0">
                  {getOrderStatus(order?.progress)}
                </label>
              )}
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              Total Belanja
            </span>
            <span className="font-bold font-12 text-success d-block">
              {formatCurrency(
                tenant?.property?.currency,
                order.sub_total_amount.toString()
              )}
            </span>
          </div>
        </div>
        <div className="col-md-3 col-12 p-3">
          <div className="d-flex justify-content-end align-items-start w-100 h-100">
            <button
              type="button"
              className="btn btn-blue btn-outline btn-sm d-sm-block"
              onClick={() => handleOpenModal(transaction)}
            >
              View Detail
            </button>
          </div>
        </div>
        {transaction.voucher && (
          <div className="col-12 px-3 py-2 mb-2">
            <label className="badge-green mb-0">
              {transaction?.voucher?.type?.name}{" "}
            </label>{" "}
            <label className="badge-purple mb-0">
              {transaction?.voucher?.name} {`( ${transaction?.voucher?.code} )`}
            </label>
          </div>
        )}
        {transaction?.transaction_note &&
          transaction?.transaction_note !== "" && (
            <div className="col-12 px-3 py-2 mb-2">
              <span
                className="font-12 p-2"
                style={{
                  background: "#ffecb3",
                  borderLeft: "6px solid #ff9800",
                  borderRadius: 4,
                }}
              >
                <strong>Catatan Pembeli: </strong>{" "}
                {transaction?.transaction_note}
              </span>
            </div>
          )}
      </div>
      <div className="bg-white d-flex justify-content-end align-items-center w-100 p-3">
        <div className="mr-auto">
          {transaction?.user?.phone &&
            transaction?.user?.phone !== "" &&
            user?.type === "staff" && (
              <button
                type="button"
                className="btn btn-blue btn-outline btn-sm font-10"
                onClick={() => handleChat(transaction)}
                style={{ paddingLeft: 33, paddingRight: 33, marginRight: 15 }}
              >
                Chat
              </button>
            )}
          {access?.patch === true && status?.print && (
            <button
              type="button"
              className="btn btn-blue btn-outline btn-sm font-10"
              style={{ paddingLeft: 15, paddingRight: 15, marginRight: 15 }}
              onClick={() => handleClickPrint(transaction?.unique_id, order)}
            >
              <PrintIcon style={{ width: 15, height: 15, marginRight: 5 }} />{" "}
              Print Out
            </button>
          )}
        </div>

        {status?.show_qr && !transaction.cons_type && (
          <button
            type="button"
            className="btn btn-show-qr ml-2"
            onClick={() => handleShowQR(transaction.unique_id, order)}
          >
            <span>
              QR For Pickup
              <ArrowForwardIosIcon
                style={{ width: 10, height: 10, marginLeft: 15 }}
              />
            </span>
          </button>
        )}

        {access?.patch === true &&
          status?.request_runner &&
          ((order?.runner_request && order?.runner_request === false) ||
            !order?.runner_request) &&
          !transaction.cons_type &&
          tenant?.property?.have_runner && (
            <button
              type="button"
              className="btn btn-order-process ml-2"
              onClick={() =>
                handleUpdateRunnerRequest(order, {
                  label: "Request Runner",
                  message: "Are you sure to request runner ?",
                  status: true,
                })
              }
            >
              <span>
                Request Runner
                <ArrowForwardIosIcon
                  style={{ width: 10, height: 10, marginLeft: 15 }}
                />
              </span>
            </button>
          )}
        {access?.patch === true &&
          status?.action?.delivery &&
          transaction?.cons_type && (
            <button
              type="button"
              className="btn btn-order-process ml-2"
              onClick={() =>
                handleUpdateProgress(order, {
                  label:
                    transaction?.cons_type === "room"
                      ? `Send To Room ${transaction?.room_number}`
                      : `Send To Table ${transaction?.table_number}`,
                  message: "Are you sure to Send this order now ?",
                  status: "complete",
                })
              }
            >
              <span>
                {transaction?.cons_type === "room"
                  ? `Send To Room ${transaction?.room_number}`
                  : `Send To Table ${transaction?.table_number}`}
                <ArrowForwardIosIcon
                  style={{ width: 10, height: 10, marginLeft: 15 }}
                />
              </span>
            </button>
          )}
        {access?.patch === true && status?.action?.process && (
          <button
            type="button"
            className="btn btn-order-process ml-2"
            onClick={() =>
              handleUpdateProgress(order, {
                label: "Process Order",
                message: "Are you sure to Process this order now ?",
                status: "process",
              })
            }
          >
            <span>
              {status?.action?.process?.label}{" "}
              <ArrowForwardIosIcon
                style={{ width: 10, height: 10, marginLeft: 15 }}
              />
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

const ListRowLoading = ({ key }) => {
  return (
    <div
      className="w-100 d-flex flex-column justify-content-start align-items-start rounded-8px border-1-secondary mb-3"
      key={key}
    >
      <div className="bg-fafafa d-flex justify-content-start align-items-center w-100 border-bottom-1-secondary">
        <div className="px-3 py-2 border-right-1-secondary">
          <span className="font-bold font-14">
            <Skeleton width={65} />
          </span>
        </div>
        <div className="px-3 py-2">
          <Skeleton width={115} />
        </div>
        <div className="px-3 py-2 ml-auto font-10 text-gray-757575">
          <Skeleton width={113} />
        </div>
      </div>
      <div className="row w-100 mx-0 bg-fafafa">
        <div className="col-md-3 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <h5 className="font-bold font-16 text-blue text-capitalize mb-0">
              <Skeleton width={80} />
            </h5>
            <span className="font-bold font-10 text-gray-757575">
              <Skeleton width={95} />
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              <Skeleton width={55} />
            </span>
            <span className="font-bold font-12 d-block">
              <Skeleton width={72} />
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              <Skeleton width={55} />
            </span>
            <span className="font-bold font-12 d-block">
              <Skeleton width={72} />
            </span>
          </div>
        </div>
        <div className="col-md-2 col-6 p-3">
          <div className="d-flex flex-column justify-content-start align-items-start w-100 h-100">
            <span className="font-10 text-gray-757575 d-block">
              <Skeleton width={55} />
            </span>
            <span className="font-bold font-12 text-success d-block">
              <Skeleton width={72} />
            </span>
          </div>
        </div>
        <div className="col-md-3 col-12 p-3">
          <div className="d-flex justify-content-end align-items-start w-100 h-100">
            <Skeleton width={100} />
          </div>
        </div>
      </div>
      <div className="bg-white d-flex justify-content-end align-items-center w-100 p-3">
        <div className="mr-auto">
          <Skeleton width={95} />
        </div>

        <Skeleton width={115} />
      </div>
    </div>
  );
};

const ListRowPanel = withWidth()(ListRow);
const ListRowLoadingPanel = withWidth()(ListRowLoading);
export { ListRowPanel, ListRowLoadingPanel };
